import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Discover Vanuatu</h3>
          <p>Your comprehensive guide to exploring the beautiful islands of Vanuatu.</p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">📘</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">📷</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">🐦</a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/categories">Categories</Link></li>
            <li><Link to="/map">Map</Link></li>
            <li><Link to="/weather">Weather</Link></li>
            <li><Link to="/tools">Useful Tools</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><a href="mailto:business@discovervanuatu.com">Business Listings</a></li>
            <li><a href="mailto:ads@discovervanuatu.com">Advertise</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <p>📧 info@discovervanuatu.com</p>
          <p>📞 +678 25 123</p>
          <p>📍 Port Vila, Vanuatu</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2026 Discover Vanuatu. All rights reserved.</p>
        <p className="disclaimer-text">
          No warranties or guarantees. All sales are final. See our <Link to="/terms-and-conditions">Terms & Conditions</Link> for details.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
